import { useMemo, useState } from 'react'
import type { FC, ChangeEvent } from 'react'

import {
  buildEntitySources,
  deriveType,
  showForeignTypesInput
} from '@app/pages/strategies/components/addCards/helpers'
import ForeignTypeInput from '@app/pages/strategies/components/addCards/queryExisting/foreignTypeInput'
import SourceNameInput from '@app/pages/strategies/components/addCards/queryExisting/sourceNameInput'
import type { Nodes } from '@app/types'
import type { Integration } from '@graphql/types'

type Props = {
  sources: Required<Pick<Integration, 'classType' | 'sourceName' | 'entityTypes'>>[]
  type: string
}

const QueryExistingEntityFields: FC<Props> = ({ sources, type }) => {
  const typeValue = deriveType(type)
  const [sourceNameValue, setSourceNameValue] = useState(type)
  const [foreignTypeValue, setForeignTypeValue] = useState('')
  const integration = useMemo(() => sources?.find((i) => i.sourceName === sourceNameValue), [sources, sourceNameValue])
  const foreignTypeOptions = useMemo(() => integration?.entityTypes || [], [integration])
  const inputSources = useMemo(() => buildEntitySources(sources), [sources])

  const handleSourceNameChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setSourceNameValue(e.target.value as Nodes)
    setForeignTypeValue('')
  }

  const handleForeignTypeChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setForeignTypeValue(e.target.value)
  }

  return (
    <>
      <SourceNameInput
        value={sourceNameValue}
        typeValue={typeValue}
        sources={inputSources}
        onChange={handleSourceNameChange}
      />
      <ForeignTypeInput
        value={foreignTypeValue}
        show={showForeignTypesInput(sourceNameValue)}
        sources={foreignTypeOptions}
        onChange={handleForeignTypeChange}
      />
    </>
  )
}

export default QueryExistingEntityFields
